import { render, staticRenderFns } from "./DefinitionsTab.vue?vue&type=template&id=2b159442&scoped=true"
import script from "./DefinitionsTab.vue?vue&type=script&lang=ts"
export * from "./DefinitionsTab.vue?vue&type=script&lang=ts"
import style0 from "./DefinitionsTab.vue?vue&type=style&index=0&id=2b159442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b159442",
  null
  
)

export default component.exports